import { patchApi } from '../utils/api'

export function updateUk({ data, id }) {
  return patchApi({ data, endpoint: `api/uk/${id}/` })
}
